module.exports = __webpack_public_path__ + "static/media/itau.f5c99fb1.png";